<div class="modal-dialog copy-activities-dialog-container">
  <div class="modal-content" cdkTrapFocus goDialogContent [goDialogContentAriaLabelledBy]="dialogTitleId">
    <div class="goreact-modal-header">
      <h4 class="modal-title" translate="modal-course-setup_title" [id]="dialogTitleId"></h4>
      <button type="button" class="close-btn" (click)="cancel()" [attr.aria-label]="'common_close' | translate">
        <i class="ficon-app-x"></i>
      </button>
    </div>
    <div class="goreact-modal-body" #content>
      <ng-container [formGroup]="form">
        <mat-radio-group color="primary" formControlName="shouldCopy">
          <mat-radio-button [value]="false">{{'modal-course-setup_start-with-blank-course' | translate }}</mat-radio-button>
          <mat-radio-button [value]="true">{{'modal-course-setup_copy-activities-from-existing-course' | translate }}</mat-radio-button>
        </mat-radio-group>
        @if (form.controls.shouldCopy.value) {
          <mat-form-field appearance="outline">
            <mat-select
              formControlName="folder"
              id="folder-selector"
              disableOptionCentering
              panelClass="offsetPanel">
              @for (folder of data.availableFolders; track folder) {
                <mat-option [value]="folder.group_id">
                  {{ folder.name }}
                </mat-option>
              }
            </mat-select>
            <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
            @if (form.controls.folder.hasError('required')) {
              <mat-error>{{'modal-course-setup_courses-dropdown-error-text' | translate}}</mat-error>
            }
          </mat-form-field>
        }
      </ng-container>
    </div>
    <div class="goreact-modal-footer">
      <button
        class="confirm-button primary-btn"
        (click)="confirm()"
        [focusOnFirstInvalidField]="{formGroup: form, formWrapper: content}"
        translate="common_continue">
      </button>
    </div>
  </div>
</div>
